module.exports = __webpack_public_path__ + "static/atuts-exp-50537f8e02a3e31933e26d971c91ca9d.svg";